(ns measure.report-builder.core
  (:require ["moment/min/moment-with-locales$default" :as moment]
            [cljs-bean.core :refer [->clj ->js]]
            [clojure.string :as str]
            [common.util :as util]))

(def entity-names
  {:report "report"
   :report-schedule "report schedule"})

(def default-values
  #js {:channel ""
       :adset-ids []
       :date-range nil
       :date-phrase nil
       :timezone util/user-timezone
       :file-format "xlsx"
       :columns []
       :metrics ["impression"]
       :name ""
       :send-emails? false
       :email []
       ;; for report schedules
       :type "report"
       :schedule nil})

(defn- valid-dates? [{:keys [date-range date-phrase]}]
  (or (and (some? (first date-range))
           (some? (second date-range)))
      (not (str/blank? date-phrase))))

(defn schema
  ([] (schema true))
  ([require-dimensions?]
   (let [min-constraint (when require-dimensions? {:min 1})]
     [:and
      [:map
       [:channel [:enum "video" "display" "ctv" "youtube" "meta" "tiktok"]]
       [:adset-ids [:vector {:min 1} :int]]
       [:date-range {:optional true} [:maybe [:tuple :any :any]]]
       [:date-phrase {:optional true} [:maybe :string]]
       [:timezone :string]

       [:file-format [:enum "xlsx" "csv"]]
       [:columns [:vector min-constraint :string]]
       [:metrics [:vector min-constraint :string]]
       [:name :string]
       [:send-emails? :boolean]
       [:email [:vector :string]]]
      [:fn {:error/message "Select a date range"
            :error/path [:date-range]}
       valid-dates?]
      [:fn {:error/message "Select a date range"
            :error/path [:date-phrase]}
       valid-dates?]
      [:fn {:error/message "Select at least one email recipient"
            :error/path [:email]}
       (fn [{:keys [send-emails? email]}]
         (or (not send-emails?)
             (seq email)))]])))

(defn generate-report-name
  "Generate report name: Report_{adset_id|multi_adset}_from({start})-to({end})_({now})"
  [{:keys [adset-ids date-range date-phrase]} entity]
  (let [adset-part (if (= 1 (count adset-ids))
                     (first adset-ids)
                     "multi-adset")
        [start-date end-date] date-range
        dates-part (or date-phrase
                       (when (or start-date end-date)
                         (str "from-" (util/format-iso-string start-date "YYYY-MM-DD")
                              "_to-" (util/format-iso-string end-date "YYYY-MM-DD"))))
        now (moment)]
    (str/join "_" [(name (or entity :report)) adset-part dates-part (util/format-iso-string now "YYYY-MM-DD_HH-mm")])))

;; BE report entities can have either :adset-id or :adset-ids,
;; whilst our form expects :adset-ids.
(defn ->adset-ids [{:keys [adset-ids adset-id] :as _report}]
  (cond
    (seq adset-ids) adset-ids
    adset-id [adset-id]
    :else []))

(defn ->form [{:keys [email] :as report}]
  (let [form-keys (conj (keys (->clj default-values)) :id)]
    (-> (select-keys report form-keys)
        (assoc :adset-ids (->adset-ids report)
               :send-emails? (boolean (seq email))
               :type "report")
        ->js)))

(defn form->payload [form-values entity]
  (let [{:keys [name date-range] :as values} (->clj form-values)
        date-range* (->> date-range
                         (mapv #(util/format-iso-string % "YYYY-MM-DD"))
                         (zipmap [:start-date :end-date]))]
    (cond-> (dissoc values :channel :date-range :send-emails?)
      (str/blank? name) (assoc :name (generate-report-name values entity))
      (= entity :report) (-> (merge date-range*)
                             (dissoc :date-phrase :type))
      true (util/filter-nils-map :remove-blank-strings? true))))
